// extracted by mini-css-extract-plugin
module.exports = {"tooltip-wrapper":"_1ri15","tooltipWrapper":"_1ri15"};